import { connect } from 'react-redux'
import { toggleSolution } from '../../../../actions/exam';
import SolutionIcon from "./SolutionIcon";

const mapStateToProps = (state, ownProps) => {
  return {

  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onToggleSolution: () => dispatch(toggleSolution())
  };
};

const SolutionIconContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SolutionIcon);

export default SolutionIconContainer
